// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  title: 'FAQ\'s',
  questions: [],
};

const faqsReducer = createReducer(initialState, {
  // eslint-disable-next-line no-unused-vars
  [types.FAQS_REQUEST_PAGE_DATA](state, action) {
    return {
      ...state,
    };
  },
  [types.FAQS_REQUEST_PAGE_DATA_SUCCESS](state, action) {
    return {
      ...state,
      ...action.data,
    };
  },
});

export default faqsReducer;
